import { functions } from "@/firebase";
import { getFunctionsOnContext } from '@/constants';

export async function initializeConversationDB({bot_id, data}){
  let response = await functions.httpsCallable(getFunctionsOnContext().START_CHAT)({bot_id, data})
  return response.data;
}

export async function sendUserResponseDB({bot_id, conversation_id, query}){
  let response = await functions.httpsCallable(getFunctionsOnContext().SEND_MESSAGE)({bot_id, conversation_id, query})
  return response.data;
}

export async function getBotInfoDB({bot_id, bot_alias, channel}){
  let response = await functions.httpsCallable(getFunctionsOnContext().GET_BOT_INFO)({bot_id, bot_alias, channel})
  return response.data;
}

export async function checkConversationStatus({bot_id, bot_alias, conversation_id}){
  let response = await functions.httpsCallable(getFunctionsOnContext().CHECK_CONVERSATION_STATUS)({bot_id, bot_alias, conversation_id})
  return response.data;
}


export async function callCloudFunction(function_name, params){
  let result = await functions.httpsCallable(function_name)(params);
  return result.data;
}
